module.exports = __webpack_public_path__ + "media/app/images/pink-logo-3e7c15f011c5e001a8ea2a74bdc20e93.png";